export const CREATE_PRODUCT_PREVIEW_DATA = 'CREATE_PRODUCT_PREVIEW_DATA';

// ------ FETCH PRODUCT PREVIEW ASSET GROUPS ------
export const FETCH_PRODUCT_PREVIEW_ASSET_GROUP_LOADING =
	'FETCH_PRODUCT_PREVIEW_ASSET_GROUP_LOADING';
export const FETCH_PRODUCT_PREVIEW_ASSET_GROUP_SUCCESS =
	'FETCH_PRODUCT_PREVIEW_ASSET_GROUP_SUCCESS';
export const FETCH_PRODUCT_PREVIEW_ASSET_GROUP_ERROR =
	'FETCH_PRODUCT_PREVIEW_ASSET_GROUP_ERROR';
